import React from "react";
import Helmet from "reactor/components/Helmet";
import MainSection from "./MainSlider";
import ServicesSection from "./ServicesSection";
import WorksSection from "./works/WorksSection";
import AboutSection from "./AboutSection";
import CustomersSection from "./CustomersSection";
import Numbers from "./Numbers";
import BlogSection from "./BlogSection";
import TestimonialsSection from "./testimonials/TestimonialsSection";
// import { TweenMax, TimelineMax, Power3, Power4 } from "gsap";
// import PageWrapper from '../../components/PageWrapper'

export default function Home() {


    // let screen = React.useRef(null);
    // let body = React.useRef(null);

    // React.useEffect(() => {


    //     var tl = new TimelineMax();
    //     tl.to(screen, {
    //     duration: 1.2,
    //     width: "100%",
    //     right: "0%",
    //     ease: Power3.easeInOut,
    //     });
    //     tl.to(screen, {
    //     duration: 1,
    //     right: "100%",
    //     ease: Power3.easeInOut,
    //     delay: 0.3,
    //     });
    //     tl.set(screen, { left: "-100%" });
    //     TweenMax.to(body, .3, {css: {
    //     opacity: "1",
    //     pointerEvents: "auto",
    //     ease: Power4.easeInOut
    //     }}).delay(2);
    //     return () => {
    //     TweenMax.to(body, 1, {css: {
    //         opacity: "0",
    //         pointerEvents: 'none'
    //     }});
    // }

    // }, []);
  return (
    <>
        <Helmet
          bodyClass="home"
          title="رواد | رواد لخدمات الويب خبرة أكثر من 12 عام في السوق السعودي "
          description="رواد هي منشأة مسجلة بسجل تجاري سعودي، متخصصة في مجال تصميم وبرمجة المواقع والتطبيقات الالكترونية، وأيضاً خدمات الاستضافة والتسويق الإلكتروني."
        />
        <MainSection />
        <ServicesSection />
        <AboutSection/>
        <WorksSection />
        {/* <Numbers /> */}
        <CustomersSection />
        {/* <TemplatesSection /> */}
        {/* <BlogSection /> */}
        {/* <TestimonialsSection /> */}
    </>
  );
}
